<script setup lang="ts">
import { useSettingsStore } from './stores/settings';
import { useColorStore } from './stores/colors';
const settingsStore = useSettingsStore();
const colorStore = useColorStore();
onMounted(() => {
  setTimezone(settingsStore.timezone);
  colorStore.updateProfitLossColor();
});
// Apply the saved theme here, not only from <ThemeSelect>: on phones that button lives in the
// menu drawer and is not mounted until the drawer opens.
watch(
  () => settingsStore.isDarkTheme,
  (dark) => {
    document.documentElement.classList.toggle('dark', dark);
    document.documentElement.classList.toggle('ft-dark-theme', dark);
  },
  { immediate: true },
);
watch(
  () => settingsStore.timezone,
  (tz) => {
    console.log('timezone changed', tz);
    setTimezone(tz);
  },
);
</script>

<template>
  <div id="app" class="flex flex-col h-dvh" :style="colorStore.cssVars">
    <NavBar />
    <Toast />
    <BodyLayout class="grow overflow-auto px-4 py-4 md:p-5" />
    <NavFooter />
    <FloatingSupportButton />
  </div>
</template>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

/* * {
  outline: 1px solid #f00 !important;
} */
</style>
